module.exports = __webpack_public_path__ + "img/cominfo.4f014529.jpg";